import { mapActions } from 'vuex'

const mixin = {
  computed: {
    isFormModified () {
      return Object.keys(this.fields).some(key => this.fields[key].changed)
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),

    controlSave () {
      return this.confirm({
        title: 'Sauvegarde modifications',
        message: 'Souhaitez-vous enregistrer les modifications ?',
        okText: 'Enregistrer',
        cancelText: 'Ignorer'
      })
        .then(confirmation => {
          return confirmation ? this.save() : Promise.resolve()
        })
    },

    clearflags () {
      Object.keys(this.fields).map(key => (this.fields[key].changed = false))
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.isFormModified && this.$store.state.auth.authenticated) {
      this.controlSave()
        .then(next)
        .catch(err => this.$store.dispatch('error', { message: err.message || err }))
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (this.isFormModified && this.$store.state.auth.authenticated) {
      this.controlSave()
        .then(next)
        .catch(err => this.$store.dispatch('error', { message: err }))
    } else {
      next()
    }
  }
}

export default mixin
